import { useMemo } from 'react'
import { Ticket } from 'types/Event'

export const useTotalPrice = (selectedSeats: string[], tickets?: Ticket[], isComplimentary?: boolean) => {
    return useMemo(() => {
        if (isComplimentary || !tickets) return 0

        return selectedSeats.reduce((total: number, seatId: string) => {
            const ticketInfo = tickets?.find((ticket) => ticket?.seat_id === seatId)
            return total + (ticketInfo ? parseInt(ticketInfo.price.toString(), 10) : 0)
        }, 0)
    }, [selectedSeats, tickets, isComplimentary])
}
